const firebaseConfig = {
  
//add your config key

};
    
    export default firebaseConfig;